import * as React from 'react';
import TwoColRow from './TwoColRow';
import { Hr, Paragraph } from '../../../../elements';
const ResidentialAddressHistoryRow = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    value.historicalAddresses
        .sort((a, b) => (a.fromDate > b.fromDate ? -1 : 1))
        .map(({ street, postalCode, town, fromDate, toDate }, index) => (React.createElement(React.Fragment, { key: index },
        React.createElement(TwoColRow, { label: i18n('common.address'), value: street }),
        React.createElement(TwoColRow, { label: i18n('common.postalcode'), value: postalCode }),
        React.createElement(TwoColRow, { label: i18n('common.postalarea'), value: town }),
        fromDate && (React.createElement(TwoColRow, { label: i18n('common.from'), value: formatDate(fromDate) })),
        toDate && (React.createElement(TwoColRow, { label: i18n('common.to'), value: formatDate(toDate) })),
        React.createElement(Hr, null)))),
    React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.taxAgency')} (${formatDate(value.verificationDate)})` }),
    value.comment !== '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
        React.createElement(Paragraph, { bold: true }, i18n('common.note')),
        React.createElement("div", { className: 'ReadReportContent__NotationContent' },
            React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
export default ResidentialAddressHistoryRow;
